import { Construction, ArrowLeft, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import liquidGradient from "../../assets/images/liquid-gradient.png";
import { Button } from "react-bootstrap";

const UnderConstruction = () => {
    return (
        <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
            {/* Background */}
            <div className="absolute inset-0 z-0">
                <div
                    className="absolute inset-0 scale-150 opacity-40 animate-gradient-shift-slow"
                    style={{
                        backgroundImage: `url(${liquidGradient})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'blur(60px)',
                    }}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/90 to-background" />
            </div>

            {/* Floating orbs */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-1/4 left-1/4 w-[400px] h-[400px] rounded-full bg-primary/10 blur-[120px] animate-float-slow" />
                <div className="absolute bottom-1/4 right-1/4 w-[300px] h-[300px] rounded-full bg-accent-foreground/10 blur-[100px] animate-float-medium" />
            </div>

            <div className="container relative z-10 px-6 text-center">
                <div className="max-w-2xl mx-auto">
                    {/* Icon */}
                    <div className="inline-flex items-center justify-center w-24 h-24 rounded-3xl glass-strong mb-8 animate-fade-in-up">
                        <Construction className="w-12 h-12 text-primary" />
                    </div>

                    {/* Badge */}
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6 animate-fade-in-up animate-delay-100">
                        <Sparkles className="w-4 h-4 text-primary animate-pulse" />
                        <span className="text-sm font-medium text-primary">Coming Soon</span>
                    </div>

                    {/* Heading */}
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight animate-fade-in-up animate-delay-200">
                        <span className="text-foreground">Page Under</span>
                        <br />
                        <span className="gradient-text-vibrant">Construction</span>
                    </h1>

                    {/* Description */}
                    <p className="text-lg md:text-xl text-foreground/60 mb-10 leading-relaxed animate-fade-in-up animate-delay-300">
                        We're working hard to bring you something amazing.
                        This page will be ready soon!
                    </p>

                    {/* CTA */}
                    <div className="animate-fade-in-up animate-delay-400">
                        <Link to="/">
                            <button type="button" className="theme-solid-btn">
                                <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" />
                                Back to Home
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnderConstruction;
